import { Button, Card, Input, message, Modal, Select } from "antd";
import { Editor, EditorState, Modifier } from "draft-js";
import React, { useState } from "react";
import "draft-js/dist/Draft.css";

import { placeholderDecorator } from "./utils";

import closeCircle from "../../assets/icons/close-circle.svg";
import paperclip from "../../assets/icons/paperclip-2.svg";
import additem from "../../assets/icons/additem.svg";
import { controller } from "./controller";

export default function AddEmailTemplateModal({ setShowAddEmailTemplate, showAddEmailTemplate, isSms }) {
  const [showDynamicSelectItem, setShowDynamicSelectItem] = useState(false);
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty(placeholderDecorator));
  const [emailTemplateName, setEmailTemplateName] = useState("");
  const [emailSubject, setEmailSubject] = useState("");

  // Placeholder options for the dropdown
  const dynamicItemOptions = [
    { label: "Patient Name", value: "Patient Name" },
    { label: "Office Name", value: "Office Name" },
  ];

  // Function to insert a placeholder at the current cursor position
  const insertPlaceholder = (placeholder) => {
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const contentStateWithPlaceholder = Modifier.insertText(currentContent, selection, placeholder);
    const newEditorState = EditorState.push(editorState, contentStateWithPlaceholder, "insert-characters");
    setEditorState(EditorState.forceSelection(newEditorState, contentStateWithPlaceholder.getSelectionAfter()));
    setShowDynamicSelectItem(false); // Close the dropdown after selection
  };

  const handleAddTemplate = async () => {
    try {
      // Get the plain text content from the editor
      const bodyContent = editorState.getCurrentContent().getPlainText();    
      //Convert placeholders to the required format:Replace "Patient Name" with "{?patient_name?}" and "Office Name" with "{?office_name ?}"
      const formattedBody = bodyContent
        .replace(/Patient Name/g, '{?patient_name?}')
        .replace(/Office Name/g, '{?office_name?}');

      // const templateToCreate = {
      //   name: emailTemplateName, 
      //   template_data: {
      //     subject: emailSubject,
      //     body: formattedBody, // Send the formatted string instead of editorState
      //   }
      // }
      const templateToCreate = {
        name: emailTemplateName,        
        subject: isSms ? undefined : emailSubject,
        text: formattedBody,
        service: isSms ? "Twilio" : "brevo",
        bulk: false,
        template: false,
      }
      
      console.log('Sending template:', templateToCreate);
      const response = await controller.sendEmailTemplate(templateToCreate, isSms);
      console.log("Email created", response);
      
      // Optional: Show success message and close modal
      message.success(`${isSms ? "SMS" : "Email"} template created successfully!`);
      setShowAddEmailTemplate(false);
      
    } catch (err) {
      console.error("Error creating template:", err);
      message.error(`${isSms ? "SMS" : "Email"} template not created!`);
    }
  }

  // console.log(editorState.getCurrentContent().getPlainText());

  return (
    <Modal
      open={showAddEmailTemplate}
      title={<span style={{ fontSize: 18 }}>Email Template Preview</span>}
      footer={
        <Button type="primary" style={{ padding: "17px 30px", marginTop: 15, fontSize: 16 }} onClick={handleAddTemplate}>
          Add Template
        </Button>
      }
      onCancel={() => setShowAddEmailTemplate(false)}
      width={600}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 20 }}>
        {/* Email/Sms Template Name */}
        <div>
          <p style={{ marginBottom: 10, fontSize: 16 }}>Email Template Name</p>
          <Input
            placeholder="Enter Email Template Name"
            value={emailTemplateName}
            onChange={(e) => setEmailTemplateName(e.target.value)}
            style={{ border: "1px solid #6B43B5" }}
          />
        </div>

        {/* Email Subject */}
        {!isSms &&
          <div>
            <p style={{ marginBottom: 10, fontSize: 16 }}>Email Subject</p>
            <Input
              placeholder="Enter Email Subject"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
              style={{ border: "1px solid #6B43B5" }}
            />
          </div>
        }

        {/* Email/Sms Text */}
        <div>
          <p style={{ color: "#848696" }}>
            Wherever you need dynamic items such as patient’s name, address, etc ..., you should add them by the{" "}
            <span style={{ color: "#6b43b5", textDecoration: "underline" }}>add icon</span> in the box below and select your need.
          </p>

          <p style={{ color: "#848696" }}>
            You can also add images and attach files wherever you want by the{" "}
            <span style={{ color: "#6b43b5", textDecoration: "underline" }}>attach icon</span>.
          </p>

          <Card className="text-email-template">
            <div
              className="custom-scroll"
              style={{
                minHeight: 100,
                maxHeight: 200,
                width: "100%",
                maxWidth: showDynamicSelectItem ? 312 : 506,
                overflowY: "auto",
              }}
            >
              <Editor
                editorState={editorState}
                onChange={setEditorState}
                blockStyleFn={() => "custom-email-editor"}
                placeholder="Write your email here..."
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "end", gap: showDynamicSelectItem ? 5 : 10 }}>
              <div>
                {!showDynamicSelectItem ? (
                  <img src={additem} alt="add-item" style={{ cursor: "pointer" }} onClick={() => setShowDynamicSelectItem(true)} />
                ) : (
                  <div style={{ position: "relative", padding: 5 }}>
                    <img
                      src={closeCircle}
                      alt="close"
                      style={{ position: "absolute", right: 0, top: 0, width: 14, zIndex: 1000, backgroundColor: "white", cursor: "pointer" }}
                      onClick={() => setShowDynamicSelectItem(false)}
                    />
                    <Select
                      options={dynamicItemOptions}
                      placeholder="Select Dynamic Item"
                      className="dynamic-select-item"
                      onChange={(value) => insertPlaceholder(value)}
                      style={{ width: 200 }}
                    />
                  </div>
                )}
              </div>

              <div>
                <img src={paperclip} alt="paper-clip" style={{ cursor: "pointer" }} />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </Modal>
  );
}
